/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { CheckConfigQueryResponse as AceXFoundPortalCoreCaqAdminQueriesCheckConfigQueryResponse } from '../models/ace/xFound/Portal/Core/CAQ/Admin/Queries/check-config-query-response';

@Injectable({
providedIn: 'root',
})

export class AdminService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiAdminCheckConfigGet
   */
  static readonly ApiAdminCheckConfigGetPath = '/api/Admin/CheckConfig';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminCheckConfigGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminCheckConfigGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqAdminQueriesCheckConfigQueryResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdminService.ApiAdminCheckConfigGetPath, 'get');
    if (params) {
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqAdminQueriesCheckConfigQueryResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAdminCheckConfigGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminCheckConfigGet$Plain(params?: {
  }): Observable<AceXFoundPortalCoreCaqAdminQueriesCheckConfigQueryResponse> {

    return this.apiAdminCheckConfigGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqAdminQueriesCheckConfigQueryResponse>) => r.body as AceXFoundPortalCoreCaqAdminQueriesCheckConfigQueryResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminCheckConfigGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminCheckConfigGet$Response(params?: {
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqAdminQueriesCheckConfigQueryResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AdminService.ApiAdminCheckConfigGetPath, 'get');
    if (params) {
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqAdminQueriesCheckConfigQueryResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAdminCheckConfigGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminCheckConfigGet(params?: {
  }): Observable<AceXFoundPortalCoreCaqAdminQueriesCheckConfigQueryResponse> {

    return this.apiAdminCheckConfigGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqAdminQueriesCheckConfigQueryResponse>) => r.body as AceXFoundPortalCoreCaqAdminQueriesCheckConfigQueryResponse)
    );
  }

  /**
   * Path part for operation apiAdminClearAllCachesApiKeyGet
   */
  static readonly ApiAdminClearAllCachesApiKeyGetPath = '/api/Admin/ClearAllCaches/{apiKey}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminClearAllCachesApiKeyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminClearAllCachesApiKeyGet$Response(params: {
    apiKey: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AdminService.ApiAdminClearAllCachesApiKeyGetPath, 'get');
    if (params) {
      rb.path('apiKey', params.apiKey, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAdminClearAllCachesApiKeyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminClearAllCachesApiKeyGet(params: {
    apiKey: string;
  }): Observable<void> {

    return this.apiAdminClearAllCachesApiKeyGet$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}